<!-- eslint disable -->
<template>
  <div class="position-relative w-100">
    <FontAwesomeIcon v-show="$wait.is(unique)" class="loading-suggestions-icon" :icon="['fas', 'spinner']" pulse />
    <b-input-group class="border-muted">
      <VueAutosuggest
        ref="licensePlateAutoSuggest"
        v-model="query"
        class="form-control form-control-sm border-muted p-0"
        :suggestions="suggestions"
        :input-props="inputProps"
        :get-suggestion-value="getSuggestionValue"
        :render-suggestion="renderSuggestion"
        @selected="selectHandler"
        @input="fetchResults"
        @keydown="queryKeyDown($event)"
        @blur="onBlur"
      >
      </VueAutosuggest>
      <b-input-group-append v-if="showClear">
        <b-btn variant="secondary" size="sm" class="text-white border-gray" @click="onClear">{{ $t('actions.clear') }}</b-btn>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import { VueAutosuggest } from 'vue-autosuggest';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CarModel from '@models/Car';

export default {
  name: 'CarAutosuggest',
  components: {
    VueAutosuggest,
    FontAwesomeIcon,
  },
  props: {
    // eslint-disable-next-line
    value: {
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    className: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Bitte geben Sie das Kennzeichen im Format „DO KK 123" ein.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      suggestions: [
        {
          data: [],
        },
      ],
      noResults: false,
      unique: Math.random()
        .toString(36)
        .substr(2, 9),
      query: '',
      selectedItem: null,
      inputProps: {
        id: 'autosuggest__input',
        placeholder: this.placeholder,
        class: `form-control frm-cntrl-custom ${this.className}`,
        disabled: this.disabled
      },
    };
  },
  watch: {
    value(val) {
      this.query = val;
    },
    errorState(val) {
      if (val) {
        this.inputProps.class = `form-control ${this.className} is-invalid`;
      } else {
        this.inputProps.class = `form-control ${this.className}`;
      }
    },
  },
  methods: {
    onClear() {
      this.$emit('on-clear');
    },
    queryKeyDown(e) {
      if(!/^[A-Za-z0-9\s]*$/.test(e.key)) {
          e.preventDefault();
      }
    },
    resetSuggestion() {
      this.suggestions = [
        {
          data: [],
        },
      ];
    },
    renderSuggestion(suggestion) {
      return suggestion.item.license_plate;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.license_plate;
    },
    // eslint-disable-next-line
    fetchResults: debounce(function(value) {
      value = value.toString().toUpperCase();
      this.query = value.toString().toUpperCase();
      this.$emit('input', value);
      this.resetSuggestion();
      this.noResults = false;
      if (value && value.length >= 3) {
        this.$wait.start(this.unique);
        CarModel.params({
          autocomplete: true,
        })
          .where('license_plate', encodeURIComponent(value))
          .where('verified', 1)
          .include('car_owner', 'car_type')
          .page(1)
          .limit(30)
          .get()
          .then((response) => {
            if (!response.data.length) this.noResults = true;
            this.suggestions = [
              {
                data: response.data,
              },
            ];
            this.$wait.end(this.unique);
          })
          .catch(() => {
            this.$wait.end(this.unique);
          });
      } else {
        this.$emit('input', null);
      }
    }, 300),
    selectHandler(item) {
      if (item) {
        this.selectedItem = item.item;
        this.$emit('car-selected', item.item);
        this.resetSuggestion();
      } else {
        if (this.suggestions[0].data.length === 1) {
          if (this.suggestions[0].data[0].license_plate === this.query) {
            this.$emit('car-selected', this.suggestions[0].data[0]);
          } else {
            this.$emit('new-car', this.query);
          }
        } else {
          // new car -- send query
          this.$emit('new-car', this.query);
        }
      }
    },
    onBlur() {
      if (this.suggestions[0].data.length === 1) {
        if (this.suggestions[0].data[0].license_plate === this.query) {
          this.$emit('car-selected', this.suggestions[0].data[0]);
        } else {
          this.$emit('new-car', this.query);
        }
      } else {
        // new car -- send query
        this.$emit('new-car', this.query);
      }
    },
  },
};
</script>
<style type="text/css">
.autosuggest-container {
  display: inline-flex;
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  border: 1px solid #ced4da;
  padding: 10px;
  flex: 1 1 auto;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.frm-cntrl-custom {
  margin: 0px;
  border: none;
  border-bottom: 1px e0e0e0;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 400px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

.loading-suggestions-icon {
  position: absolute;
  top: 30%;
  right: 5%;
  z-index: 1;
}
</style>
